import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class CommissionPaymentService {
  constructor(private http: HttpClientService) {}

  public post(commission_payment_request): Observable<any> {
    return this.http
      .post("/api/commission_payment_requests", commission_payment_request)
      .pipe(tap((_) => console.log("CommissionPaymentService.post: Ok.")));
  }

  public delete(id): Observable<any> {
    return this.http
      .delete("/api/commission_payment_requests/" + id)
      .pipe(tap((_) => console.log("CommissionPaymentService.delete: Ok.")));
  }

  public updateCommissionPaymentRequest(commission_payment_request: any) {
    const options = {
      commission_payment_request: commission_payment_request,
    };
    return this.http
      .put("/api/commission_payment_requests/" + commission_payment_request.id, options)
      .pipe(tap((_) => console.log("CommissionPaymentService.updateCommissionPaymentRequest: Ok.")));
  }

  public getAll(filters): Observable<any[]> {
    let options = {
      params: filters,
    };
    return this.http
      .get("/api/commission_payment_requests/all", options)
      .pipe(tap((_) => console.log("CommissionPaymentService.getAll: Ok.")));
  }

  public getByUser(filters): Observable<any[]> {
    let options = {
      params: filters,
    };
    return this.http
      .get("/api/commission_payment_requests/search_by_user", options)
      .pipe(tap((_) => console.log("CommissionPaymentService.getByUser: Ok.")));
  }

  public downloadRequestsSelected(ids): Observable<any[]> {
    let options = {
      responseType: "blob" as "json",
      params: {
        "ids[]": ids,
      },
    };
    return this.http
      .get("/api/commission_payment_requests/requested_to_csv", options)
      .pipe(tap((_) => console.log("CommissionPaymentService.downloadRequestsSelected: Ok.")));
  }

  public updateByBatches(ids, new_status: string): Observable<any[]> {
    let options = {
      ids: ids,
      new_status: new_status,
    };
    return this.http
      .post("/api/commission_payment_requests/update_by_batches", options)
      .pipe(tap((_) => console.log("CommissionPaymentService.updateByBatches: Ok.")));
  }

  public getCommissionRequestsCount(): Observable<any> {
    return this.http
      .get("/api/commission_payment_requests/requests_count")
      .pipe(tap((_) => console.log("CommissionPaymentService.getCommissionRequestsCount: Ok.")));
  }

  public notifyPaymentConfirmation(commission_payment_request_id: number): Observable<any> {
    return this.http
      .post("/api/commission_payment_requests/" + commission_payment_request_id + "/notify_payment_confirmation", {})
      .pipe(tap((_) => console.log("CommissionPaymentService.notifyPaymentConfirmation: Ok.")));
  }

  public downloadPaymentReceipt(commission_payment_request_id: number): Observable<any> {
    return this.http
      .post(
        "/api/commission_payment_requests/" + commission_payment_request_id + "/download_payment_receipt",
        {},
        { responseType: "blob" as "json" }
      )
      .pipe(tap((_) => console.log("CommissionPaymentService.downloadPaymentReceipt: Ok.")));
  }

  public processData(content): Observable<any> {
    return this.http
      .post("/api/commission_payment_requests/process_data", { content })
      .pipe(tap((_) => console.log("CommissionPaymentService.processData: Ok.")));
  }
}
